(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('ProfileController', ProfileController);

  /* ngInject */
  function ProfileController($timeout, Flash, config, formErrorsService, profileService, sessionService, Upload) {

    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.activate = activate;
    vm.config = config;
    vm.profileForm = {};
    vm.deleteAvatar = deleteAvatar;
    vm.getProfile = getProfile;
    vm.profile = {};
    vm.saveProfile = saveProfile;
    vm.uploadAvatar = uploadAvatar;

    vm.activate();

    function activate() {
      getProfile();
    }

    function getProfile() {
      profileService(sessionService.getAuthToken()).get(response => {
        vm.profile = response;
      });
    }

    function saveProfile(profile) {
      vm.clearFormErrors();
      profileService(sessionService.getAuthToken()).update(profile, _updateProfileSuccess, _updateProfileFailure);
    }

    function _updateProfileSuccess(_response) {
      Flash.create('success', 'Profile was successfully updated.');
    }

    function _updateProfileFailure(response) {
      Flash.create('danger', 'An error occurred. Please correct the errors on the form below and resubmit.');
      vm.setFormErrors(vm.profileForm, response);
    }

    function deleteAvatar() {
      profileService(sessionService.getAuthToken()).removeAvatar(_removeAvatarSuccess, _removeAvatarFailure);
    }

    function uploadAvatar(avatar) {
      avatar.upload = Upload.upload({
        url: `${config.complianceFrameworkApiEndpoint}/api/profile/avatar`,
        method: 'POST',
        data: {avatar: avatar},
        headers: {
          'Authorization': `Token token=${sessionService.getAuthToken()}`
        }
      });

      avatar.upload.then(response => {
        $timeout(() => {
          sessionService.setUser(response.data);
          vm.profile = response.data;
          Flash.create('success', 'Avatar successfully updated.');
        });
      }, _response => {
        Flash.create('danger', 'An unexpected error occurred uploading avatar.');
      });
    }

    function _removeAvatarSuccess(response) {
      Flash.create('success', 'Avatar successfully removed.');
      vm.profile = response;
    }

    function _removeAvatarFailure(_response) {
      Flash.create('danger', 'An error occurred removing avatar from profile.');
    }
  }
})();
